module.exports = __webpack_public_path__ + "img/ins-advantage2.7b6c3540.svg";